import { Component, ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { Router } from '@angular/router';
import { AgencyService } from "../Services/Agency.service";
import { ManagerProperties } from '../models/ManagerProperties';
declare var $;

@Component({
  selector: 'app-manager-list',
  templateUrl: './manager-list.component.html',
  styleUrls: ['./manager-list.component.css']
})
/** ManagerList component*/
export class ManagerListComponent {
  /** ManagerList ctor */
  constructor(private agencyService: AgencyService, private router: Router) { }

  @ViewChild('agencyGrid', { static: false }) dataGrid: DxDataGridComponent;
  managerList: ManagerProperties[] = [];
  collapsed = false;

  contentReady = (e) => {
    $(".dx-datagrid-headers").css({ "background-color": "white", "color": "#212529", "font-weight": "bold" });
    if (!this.collapsed) {
      this.collapsed = true;
      e.component.expandRow(["EnviroCare"]);
    }
  };

  ngOnInit() {

    this.LoadManagerList();
  }
  LoadManagerList() {
    try {
      let isAgency;
      let loginAgency = ""
      if ((localStorage.getItem("AgencyId") != undefined) && (localStorage.getItem("AgencyId") != "") && (localStorage.getItem("AgencyId") != null)) {
        loginAgency = localStorage.getItem("AgencyId")
        if (loginAgency.includes("B"))
          isAgency = false;
        else
          isAgency = true;
        this.agencyService.GetManagersByAgency_Branch(loginAgency, isAgency).subscribe((data) => {
          this.managerList = data;
        });

      }
    }
    catch (e) { }
  }
}
